import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import styles from './HeaderStoreLocationMap.module.scss';
import { StoreLocationMap } from '../../store-location-map/StoreLocationMap';
export const HeaderStoreLocationMap = ({ userCountryCode, dealerCode, latitude, longitude }) => {
    return (_jsx(StoreLocationMap, { userCountryCode: userCountryCode, dealerCode: dealerCode, latitude: latitude, longitude: longitude, className: cx('mb-3', styles['store-location-map-container']) }));
};
